import { c as _c } from "react/compiler-runtime";
import { SEOMetadata, SEOMetadataProps } from '@src/components/sco/utilities/SEOMetadata';
import { PodcastEpisode } from '@src/graphql-types';
import { gql } from '@src/lib/gql';
import { startupsUrl } from '@src/lib/startups-url';
import React from 'react';
export const PodcastEpisodeSEO = props => {
  const $ = _c(8);
  let t0;
  if ($[0] !== props.podcastEpisode.description || $[1] !== props.podcastEpisode.seoDescription || $[2] !== props.podcastEpisode.seoTitle || $[3] !== props.podcastEpisode.slug || $[4] !== props.podcastEpisode.title) {
    const seoProps = {};
    seoProps.title = props.podcastEpisode.seoTitle || props.podcastEpisode.title;
    seoProps.description = props.podcastEpisode.seoDescription || props.podcastEpisode.description;
    const t1 = `/podcast/${props.podcastEpisode.slug}`;
    let t2;
    if ($[6] !== t1) {
      t2 = startupsUrl(t1);
      $[6] = t1;
      $[7] = t2;
    } else {
      t2 = $[7];
    }
    seoProps.url = t2;
    t0 = <><SEOMetadata {...seoProps} /></>;
    $[0] = props.podcastEpisode.description;
    $[1] = props.podcastEpisode.seoDescription;
    $[2] = props.podcastEpisode.seoTitle;
    $[3] = props.podcastEpisode.slug;
    $[4] = props.podcastEpisode.title;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  return t0;
};
PodcastEpisodeSEO.fragments = {
  PodcastEpisode: () => gql`
    fragment _ on PodcastEpisode {
      id
    }
  `
};